import React, { useState, useEffect } from 'react'
import { Image as ChakraImage } from '@chakra-ui/react'
import { storage } from '../lib/firebase-client'

type Props = {
	url: string
	alt?: string
	width?: string
}

export const StorageImage = (props: Props) => {
	const { url, alt, width } = props

	const [imageSrc, setImageSrc] = useState('')

	useEffect(() => {
		const fetchImageSrc = async (url: string) => {
			try {
				const ref = storage.ref(url)
				const imageSrc = await ref.getDownloadURL()
				setImageSrc(imageSrc)
			} catch (e) {
				// 画像がない場合
			}
		}

		url && fetchImageSrc(url)
	}, [url])

	return imageSrc ? <ChakraImage src={imageSrc} alt={alt} w={width} /> : <></>
}
